// Blocca l'app quando la versione installata e' troppo vecchia.
//
// La versione minima la decide il server (GET /api/version), cosi' si puo'
// obbligare all'aggiornamento cambiando un numero, senza pubblicare nulla.
//
// Due regole di prudenza:
// - nel browser non blocca mai, non essendoci uno store da cui aggiornare;
// - se il controllo non riesce (server irraggiungibile, telefono offline)
//   l'app parte lo stesso: meglio un controllo saltato che un'app inutilizzabile.

import React, { useEffect, useState } from 'react';
import { Button } from 'antd';
import axios from 'axios';
import { Capacitor } from '@capacitor/core';
import { App as CapacitorApp } from '@capacitor/app';
import { apiUrl } from './config';

const UpdateGate = ({ children }) => {
    const [blocco, setBlocco] = useState(null);

    useEffect(() => {
        let annullato = false;

        const controlla = async () => {
            if (!Capacitor.isNativePlatform()) return;

            try {
                const info = await CapacitorApp.getInfo();
                const piattaforma = Capacitor.getPlatform();

                const { data } = await axios.get(`${apiUrl}/api/version`, {
                    params: { platform: piattaforma, version: info.version },
                    timeout: 8000,
                });

                if (!annullato && data.updateRequired) {
                    setBlocco({
                        versioneInstallata: info.version,
                        versioneRichiesta: data.minVersion,
                        storeUrl: data.storeUrl,
                    });
                }
            } catch (error) {
                // Nessun blocco se non si riesce a verificare.
                console.warn('Controllo versione non riuscito:', error?.message);
            }
        };

        controlla();
        return () => { annullato = true; };
    }, []);

    if (!blocco) return children;

    return (
        <div style={{
            position: 'fixed',
            inset: 0,
            zIndex: 9999,
            background: 'var(--sfondo)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '32px 24px',
            textAlign: 'center',
        }}>
            <h1 style={{ fontSize: 24, margin: '0 0 12px', color: 'var(--inchiostro)' }}>
                Aggiorna FitLab
            </h1>
            <p style={{ fontSize: 16, color: 'var(--testo)', margin: '0 0 8px', maxWidth: 340 }}>
                Questa versione dell'app non è più utilizzabile. Scarica l'aggiornamento
                per continuare ad allenarti.
            </p>
            <p style={{ fontSize: 13, color: 'var(--testo-tenue)', margin: '0 0 28px' }}>
                Installata {blocco.versioneInstallata} · richiesta {blocco.versioneRichiesta}
            </p>
            <Button
                type="primary"
                size="large"
                style={{ background: 'var(--primario)', borderColor: 'var(--primario)', minWidth: 200, height: 48 }}
                onClick={() => window.open(blocco.storeUrl, '_blank')}
            >
                Aggiorna ora
            </Button>
        </div>
    );
};

export default UpdateGate;
